import { Injectable } from '@angular/core';
import { environment } from '@rocksoft/environment';
import { HubService } from './hub.service';

@Injectable({ providedIn: 'root' })
export class AppleSyncHubService extends HubService {
  constructor() {
    super(`${environment.applesync.api}/hubs/apple-sync`);
  }
}
